import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode/DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode';

const CancelAndRefundOrDiscountOrderItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The items have been discounted.'}
    />
  );
};

export default CancelAndRefundOrDiscountOrderItemsThenSendMacro;
